
    if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.initCart()
            PubSub.subscribe('cart-updated', this.openCart.bind(this))
            PubSub.subscribe('cart-updated', this.updateCart.bind(this))
        }

        initCart() {
            this.productRemove = this.querySelectorAll('.cart_line_item-remove')
            this.productQty = this.querySelectorAll('.cart_line_item-qty__update')
            this.querySelector('.cart-drawer-close').addEventListener('click', this.closeCart.bind(this))
            this.querySelector('.close_cart_drawer').addEventListener('click', this.closeCart.bind(this))
            this.productRemove.forEach((e) => {
                e.addEventListener('click', (e) => {
                    this.removeProduct(e.target.dataset.variant_id)
                })
            })
            this.productQty.forEach((e) => {
                e.addEventListener('click', (e) => {
                    this.changeCount(e.target.dataset.variant_id, e.target.dataset.quantity)
                })
            })
        }
        openCart(){
            this.classList.add('active')
        }
        closeCart(){
            this.classList.remove('active')
        }
        updateCart() {
            fetch(window.theme.shopUrl + `?section_id=${this.dataset.sectionid}`)
                .then((res) => res.text())
                .then((data) => {
                    const html = new DOMParser().parseFromString(data, 'text/html')
                     this.querySelector('.cart_container').innerHTML = html.querySelector('.cart_container').innerHTML
                    console.log(html)
                    document.querySelector('.cart-count-bubble > span') != null ? document.querySelector('.cart-count-bubble > span').innerHTML =
                            html.querySelector('.cart_totals-title').dataset.item_count :
                        // add - <div class="cart-count-bubble"><span aria-hidden="true">7</span><span class="visually-hidden">5 items</span>
                        //           </div> after .visually-hidden
                        document.querySelector('.icon-cart-empty').insertAdjacentHTML('afterend', `
                               <div class="cart-count-bubble">
                                 <span aria-hidden="true">
                                    ${html.querySelector('.cart_totals-title').dataset.item_count}
                                    </span>
                                    <span class="visually-hidden">${html.querySelector('.cart_totals-title').dataset.item_count}
                                     items</span>
                                     </div>`
                        )
                       this.initCart()
                })
                .catch(error => {
                    console.error('Error', error)
                });
        }

        removeProduct(id) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    'id': id,
                    'quantity': 0,
                }),
            };
            fetch(window.theme.shopUrl + '/cart/change.js', requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then((data) => {
                    this.updateCart()
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        changeCount(id, quantity) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    'id': id,
                    'quantity': quantity,
                }),
            };
            fetch(window.theme.shopUrl + '/cart/change.js', requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then((data) => {
                    this.updateCart()
                    PubSub.publish(PubSub.EVENTS.cartUpdated)
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

    })
}



